import React from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { Navbar, Sidebar } from 'flowbite-react';

const Layout: React.FC = () => {
  const navigate = useNavigate();

  const handleLogout = async () => {
    localStorage.removeItem('adminToken');
    await Promise.resolve();
    navigate('/login');
  };

  return (
    <div className="flex h-screen bg-gray-50">
      <Sidebar className="w-64">
        <Sidebar.Items>
          <Sidebar.ItemGroup>
            <Sidebar.Item href="/dashboard">
              Dashboard
            </Sidebar.Item>
            <Sidebar.Item href="/users">
              Users
            </Sidebar.Item>
            <Sidebar.Item href="#" onClick={(e:any) => {
              e.preventDefault();
              handleLogout();
            }}>
              Logout
            </Sidebar.Item>
          </Sidebar.ItemGroup>
        </Sidebar.Items>
      </Sidebar>

      <div className="flex-1 flex flex-col overflow-hidden">
        <Navbar fluid>
          <Navbar.Brand href="/">
            <span className="self-center whitespace-nowrap text-xl font-semibold dark:text-white">
              Admin Dashboard
            </span>
          </Navbar.Brand>
        </Navbar>

        <main className="flex-1 overflow-x-hidden overflow-y-auto bg-gray-100 p-6">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default Layout; 